/* eslint-disable unicorn/no-null */

import type { FC } from 'react';
import { useMemo } from 'react';
import { Skeleton } from '@mantine/core';
import { ActiveVersionBadge } from './ActiveVersionBadge';
import { useCustomerLinkQuery } from '@/pages/Project/components/Files/CustomerLinks.queries';
import { useProjectVersionsQuery } from '@/pages/Project/components/Files/ProjectVersions.queries';

interface ActiveVersionIndicatorProps {
    projectIdn?: string;
}

const ActiveVersionIndicator: FC<ActiveVersionIndicatorProps> = ({
    projectIdn
}) => {
    const customerLink = useCustomerLinkQuery(projectIdn);
    const versions = useProjectVersionsQuery(projectIdn);

    const version = useMemo(
        () =>
            versions.data?.find(
                (v) => v.id === customerLink.data?.project_version_id
            ) ?? null,
        [versions.data, customerLink.data]
    );

    if (customerLink.isPending) {
        return <Skeleton height={20} width={140} />;
    }

    return <ActiveVersionBadge link={customerLink.data} version={version} />;
};

export default ActiveVersionIndicator;
